import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
  selector: "loader",
  templateUrl: "loader.html",
  styleUrls: ["loader.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class LoaderComponent {
  small = input(false);
  detailed = input(false);
  text = input("");
  paddingSize = input("medium");
  iconOnly = input(false);
}
